var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalandarIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.33317 8.7V10.3H5.77762V8.7H7.33317ZM10.4443 8.7V10.3H8.88873V8.7H10.4443ZM13.5554 8.7V10.3H11.9998V8.7H13.5554ZM15.1109 3.1C15.9701 3.1 16.6665 3.81634 16.6665 4.7V15.9C16.6665 16.7837 15.9701 17.5 15.1109 17.5H4.22206C3.35873 17.5 2.6665 16.78 2.6665 15.9V4.7C2.6665 3.81634 3.36295 3.1 4.22206 3.1H4.99984V1.5H6.55539V3.1H12.7776V1.5H14.3332V3.1H15.1109ZM15.1109 15.9V7.1H4.22206V15.9H15.1109ZM7.33317 11.9V13.5H5.77762V11.9H7.33317ZM10.4443 11.9V13.5H8.88873V11.9H10.4443ZM13.5554 11.9V13.5H11.9998V11.9H13.5554Z",
    fill: "#3A4669"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalandarIcon);
export default __webpack_public_path__ + "static/media/calandarIcon.19de398a1ebad0818dd6e70cb21fb01a.svg";
export { ForwardRef as ReactComponent };